export function sortWithSelectedFirst<T extends { id: number }>(
  items: T[],
  isSelected: (id: number) => boolean,
): T[] {
  return [...items].sort((a, b) => {
    const aSelected = isSelected(a.id);
    const bSelected = isSelected(b.id);
    if (aSelected === bSelected) {
      return 0;
    }
    return aSelected ? -1 : 1;
  });
}

export function shouldShowSelectedDivider<T extends { id: number }>(
  items: T[],
  index: number,
  isSelected: (id: number) => boolean,
): boolean {
  if (!items?.length || index >= items.length - 1) {
    return false;
  }

  return isSelected(items[index].id) && !isSelected(items[index + 1].id);
}
